// src/components/infografia/templates/TemplateSelector.jsx
import React from 'react';
import { FaStar, FaGift, FaComment, FaPaintBrush, FaSpinner } from 'react-icons/fa';
import { useTemplates } from '../../../hooks/useTemplates';

// Mapa de iconos por categoría (fallback)
const ICON_MAP = {
    feedback: FaStar,
    promocional: FaGift,
    reviews: FaComment,
    custom: FaPaintBrush,
    default: FaPaintBrush
};

const TemplateSelector = ({ onSelect, marca }) => {
    const { templates, loading, error, useHardcoded } = useTemplates({ esPublico: true });

    // Función para obtener el icono correcto
    const getIcon = (template) => {
        // Si el template tiene un icono definido y es una función (React component), úsalo
        if (template.icon && typeof template.icon === 'function') {
            return template.icon;
        }
        // Si tiene un string de icono, intenta buscarlo en el mapa
        if (typeof template.icono === 'string' && ICON_MAP[template.icono]) {
            return ICON_MAP[template.icono];
        }
        // Si tiene categoría, busca por categoría
        if (template.categoria && ICON_MAP[template.categoria]) {
            return ICON_MAP[template.categoria];
        }
        // Por defecto
        return ICON_MAP.default;
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center py-12">
                <FaSpinner className="w-8 h-8 text-blue-600 animate-spin" />
                <span className="ml-3 text-gray-600">Cargando templates...</span>
            </div>
        );
    }

    if (error && !useHardcoded) {
        return (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-red-600">Error al cargar templates: {error}</p>
                <p className="text-sm text-red-500 mt-2">Usando templates predeterminados.</p>
            </div>
        );
    }

    return (
        <div>
            {useHardcoded && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
                    <p className="text-sm text-yellow-800">
                        ℹ️ Usando templates predeterminados. Los templates del backend no están disponibles todavía.
                    </p>
                </div>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {templates.map((template) => {
                    const Icon = getIcon(template);
                    const displayName = template.nombre || template.name;
                    const displayDescription = template.descripcion || template.description;
                    const templateId = template._id || template.id;

                    return (
                        <button
                            key={templateId}
                            onClick={() => onSelect(template)}
                            className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all transform hover:scale-105 border-2 border-transparent hover:border-blue-500"
                        >
                            <div className="flex flex-col items-center text-center">
                                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                                    <Icon className="w-8 h-8 text-blue-600" />
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                    {displayName}
                                </h3>
                                <p className="text-sm text-gray-600 mb-4">
                                    {displayDescription}
                                </p>
                                <div className="text-xs text-gray-500">
                                    {template.dimensiones.ancho} x {template.dimensiones.alto} px
                                </div>
                                {template.esPublico && (
                                    <div className="mt-2">
                                        <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
                                            Público
                                        </span>
                                    </div>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default TemplateSelector;

